import React from 'react'
import Furthur_pages from '../../component/virtualstart/furthur_pages/index';

export function FurthurPages() {
  return (
    <Furthur_pages />
  )
}
